import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import * as S from '../GraciasPage.styles';
import PaymentInfo from './PaymentInfo';
import PaymentCode from './PaymentCode';
import WhatsAppButton from './WhatsAppButton';
import { generateWhatsAppMessage } from '../utils';

/**
 * Estado de pago exitoso
 */
const SuccessState = ({ t, paymentId }) => {
  return (
    <>
      <S.StatusIcon $status="success">
        <FaCheckCircle />
      </S.StatusIcon>
      <S.Title>{t('gracias.success.title')}</S.Title>
      <S.Message>{t('gracias.success.message')}</S.Message>
      
      <PaymentInfo t={t} />
      
      <PaymentCode 
        label={t('gracias.success.paymentCode')} 
        code={paymentId} 
      />
      
      <S.ButtonGroup>
        <WhatsAppButton href={generateWhatsAppMessage(paymentId)} />
      </S.ButtonGroup>
    </>
  );
};

export default SuccessState;

